import styled from 'styled-components';
import { devices } from '../../../../juristec-ui/core/breakpoints';
import { gap } from '../../../../juristec-ui/styles/theme';

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ExternalContainer = styled(Column)`
  display: flex;
  flex-direction: column;
  width: 50%;
  min-width: 700px;
  height: 40%;
  min-height: 500px;
`;

export const ModalContainer = styled(Column)`
  display: flex;
  flex-direction: column;
  align-items: stretch;
  width: 100%;
  min-height: 450px;
  padding: 20px;
  box-sizing: border-box;
  user-select: none;
  overflow: auto;
  ${gap('20px', 'column')};
  @media ${devices.phoneS} {
    flex-direction: column;
    min-height: auto;
  }
`;

export const SelectContainer = styled(Column)`
  width: 100%;

  & .select-error-msg {
    font-size: 10px;
    color: ${({ theme }) => theme.error};
  }
`;

export const NewTutorialContainer = styled(Column)`
  box-sizing: border-box;
  width: 100%;
  flex: 0 0 100%
  margin: 0;
  justify-content: flex-start;
  @media ${devices.phoneS} {
    width: 100%;
    flex: 1;
  }
  & > span {
    align-self: end;
  }
`;

export const TutorialInfo = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;

  gap: 24px;

  width: 100%;
`;

export const TutorialFields = styled(Column)`
  width: 100%;

  gap: 12px;
`;

export const Description = styled.div`
  width: 100%;

  display: flex;
  align-items: stretch;
`;

export const LinkSection = styled.div`
  width: 100%;
`;

export const InputWrapper = styled.div`
  margin: 5px 0;
  width: 100%;
  & span {
    position: absolute;
  }
`;

export const FormLine = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  width: 100%;
  & .dash_color_icon {
    margin-left: 1rem;
  }
  margin-bottom: 15px;
`;

export const Preview = styled.div`
  box-sizing: border-box;

  width: 100%
  aspect-ratio: 16 / 9;

  min-height: 350px;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 8px;

  background-color: ${({ theme }) => theme.containerHover};

  overflow: hidden;

  @media ${devices.phoneS} {
    width: 100%;
    flex: 1;
    min-height: 250px;
  }
`;

export const PreviewVideo = styled.iframe`
  width: 100%;
  aspect-ratio: 16 / 9;

  border: 0;
  border-radius: 8px;
`;

export const PreviewMessage = styled.div<{error: boolean}>`
  padding: 20px;

  text-align: center;

  color: ${({ theme, error }) => (error ? theme.error : theme.text)};

  font-size: 0.9rem;
`;
